module.exports = __webpack_public_path__ + "img/two1Orange.eb16cbd2.png";